import { actionClient } from '@/api'

export default {

  namespaced: true,

  state: {

  },


  mutations: {

  },

  actions: {

    async upload({ commit }, { file, folder }) {
      const data = new FormData();
      data.append('file', file);
      data.append('folder', folder)
      data.append('type', 'image')
      return await actionClient.formPost('upload', data)
    }

  }


}
